<lib-image
	[image]="undefined"
	[alt]="'Avatar'"
	[imageSize]="'original'"
	[maxHeight]="calculatedSize()"
	[maxWidth]="calculatedSize()"
	[avatarName]="name()"
></lib-image>
